import { UserFriendlyError } from "../../../../../common/utils/base_error";
import { IUpdateSatisfacaoClienteUseCase } from "../../../presentation/useCases/update/update_satisfacao_cliente_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * UpdateSatisfacaoClienteUseCase
 */

export class UpdateSatisfacaoClienteUseCase implements IUpdateSatisfacaoClienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async updateSatisfacaoCliente(
    idSatisfacaoCliente: number,
    status: number,
    centroCusto: number,
    cliente: number | null,
    nomeCliente: string | null,
    data: Date | null,
    preencher: boolean,
  ): Promise<void> {
    if (preencher) {
      if (nomeCliente === null || nomeCliente.length === 0) {
        throw new UserFriendlyError('O campo cliente deve ser preenchido');
      }
    } else {
      if (cliente === null || cliente === 0) {
        throw new UserFriendlyError('O campo cliente deve ser preenchido');
      }
    }

    await this.repository.updateSatisfacaoCliente(
      idSatisfacaoCliente,
      status,
      centroCusto,
      cliente,
      nomeCliente,
      data,
    );
  }
}
